export const columnSize = (columns: number) => {
  if (!columns) return 12;
  let size: number = 12;
  if (Number(columns)) {
    size = 12 / Number(columns);
  }
  return size;
};
